// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customerSelectorToolbarStyles } from "@insite/content-library/Components/CustomerSelectorToolbar";
import getColor from "@insite/mobius/utilities/getColor";
import Search from "@steiner/XDL/Icons/Search";
import { getInputStyleWithIcon, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

customerSelectorToolbarStyles.wrapper = {
    css: css`
        display: flex;
        gap: 12px;
        border-bottom: 1px solid ${getColor("common.border")};
        padding-bottom: 10px;
        ${xScreen("lte", "xs")} {
            flex-wrap: wrap;
        }
    `,
};

customerSelectorToolbarStyles.searchTextField = {
    ...mergeWithCss(getInputStyleWithIcon(Search), {
        cssOverrides: {
            formField: css`
                ${xScreen("gte", "md")} {
                    max-width: 350px;
                }
            `,
        },
    }),
};

customerSelectorToolbarStyles.searchButton = {
    variant: "primary",
    css: css`
        margin-left: auto;
        ${xScreen("lte", "xs")} {
            width: 100%;
            margin-left: initial;
        }
    `,
};
